module.exports = __webpack_public_path__ + "static/tab_course.f8e98186.png";